/**
 * Раннее вооружение фронт-ловушки mini-watch — ДО парса env.ts и initSDK.
 *
 * Зачем отдельный модуль, а не строка в main.tsx: ES-импорты вычисляются по
 * порядку и ДО тела импортирующего модуля. Если ставить initWatch в теле
 * main.tsx, ловушка встаёт на пост уже ПОСЛЕ вычисления `import { env }` — а
 * именно там zod fail-fast (CANON SP1) может бросить на битой конфигурации.
 * Импортируя этот модуль ПЕРВЫМ, мы вешаем глобальные слушатели
 * 'error'/'unhandledrejection' раньше любого нашего кода, поэтому в mini-watch
 * уезжают даже ошибки раннего бута/конфигурации, а не только рантайм после старта.
 *
 * Читаем raw import.meta.env (zod-парса ещё не было — и он сам может упасть).
 * Vite инлайнит VITE_*-переменные в бандл на этапе сборки. initWatch никогда не
 * бросает; если ключей нет — просто спит (ничего не шлёт).
 */
import { initWatch } from 'mini-watch/frontend';

const key = import.meta.env.VITE_MW_KEY;
const url = import.meta.env.VITE_MW_URL;

if (key && url) {
  initWatch({ key, url, env: import.meta.env.MODE });
}
